import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage';
@Injectable({
  providedIn: 'root'
})
export class StoreService {

  data: any;
  tmp: any = {};
  private STORE_KEY = 'orangemobile-bao';
  constructor(private storage: Storage) {
    this.load().then(d => {
      console.log('Data', d);
    }).catch(err => {
      console.log('Error', err);
    });
  }

  load() {
    if (this.data) {
      return Promise.resolve(this.data);
    }
    return this.storage.get(this.STORE_KEY).then(value => {
      if (value) {
        this.data = value;
        return this.data;
      } else {
        return this.setAll({}).then((val) => {
          this.data = val;
        });
      }
    });
  }

  merge(settings: any) {
    for (const k of Object.keys(settings)) {
      this.data[k] = settings[k];
    }
    return this.save();
  }

  setValue(key: string, value: any) {
    this.data[key] = value;
    return this.storage.set(this.STORE_KEY, this.data);
  }

  setAll(value: any) {
    return this.storage.set(this.STORE_KEY, value);
  }

  getValue(key: string) {
    return this.storage.get(this.STORE_KEY)
      .then(settings => {
        return settings[key];
      });
  }

  save() {
    return this.setAll(this.data);
  }

  get allSettings() {
    return this.data;
  }
}
